import { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";

// Constants – keep eagerly loaded
import {
  ACCO,
  ACCO_ADD,
  ACCO_EDIT,
  BARCODE,
  BARCODE_ADD,
  BARCODE_EDIT,
  BUNITO,
  BUNITO_ADD,
  BUNITO_EDIT,
  CANVAS,
  CANVAS_ADD,
  CANVAS_EDIT,
  CHROMA_COLLECTION,
  CHROMA_COLLECTION_ADD,
  CHROMA_COLLECTION_EDIT,
  CHROMA_COMPOSITE,
  CHROMA_COMPOSITE_ADD,
  CHROMA_COMPOSITE_EDIT,
  CHROMA_RIBBED,
  CHROMA_RIBBED_ADD,
  CHROMA_RIBBED_EDIT,
  FURROW,
  FURROW_ADD,
  FURROW_EDIT,
  FURROW_LITE,
  FURROW_LITE_ADD,
  FURROW_LITE_EDIT,
  FURROW_REGANTO,
  FURROW_REGANTO_ADD,
  FURROW_REGANTO_EDIT,
  MARVEL,
  MARVEL_ADD,
  MARVEL_EDIT,
  MATTLE,
  MATTLE_ADD,
  MATTLE_EDIT,
  NOVEL,
  NOVEL_ADD,
  NOVEL_EDIT,
  REGANTO_CLASSIC,
  REGANTO_CLASSIC_ADD,
  REGANTO_CLASSIC_EDIT,
  REGANTO_DEZINER,
  REGANTO_DEZINER_ADD,
  REGANTO_DEZINER_EDIT,
  REGANTO_PREMIER,
  REGANTO_PREMIER_ADD,
  REGANTO_PREMIER_EDIT,
} from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy-loaded series product masters
const Barcode = lazy(() => import("app/pages/Master/SeriesProductMaster/Barcode"));
const AddBarcode = lazy(() => import("app/pages/Master/SeriesProductMaster/Barcode/AddBarcode"));

const ChromaCollection = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaCollection"));
const AddChromaCollection = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaCollection/AddChromaCollection"));

const ChromaComposite = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaComposite"));
const AddChromaComposite = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaComposite/AddChromaComposite"));

const ChromaRibbed = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaRibbed"));
const AddChromaRibbed = lazy(() => import("app/pages/Master/SeriesProductMaster/ChromaRibbed/AddChromaRibbed"));

const Furrow = lazy(() => import("app/pages/Master/SeriesProductMaster/Furrow"));
const AddFurrow = lazy(() => import("app/pages/Master/SeriesProductMaster/Furrow/AddFurrow"));

const Bunito = lazy(() => import("app/pages/Master/SeriesProductMaster/Bunito"));
const AddBunito = lazy(() => import("app/pages/Master/SeriesProductMaster/Bunito/AddBunito"));

const Mattle = lazy(() => import("app/pages/Master/SeriesProductMaster/Mattle"));
const AddMattle = lazy(() => import("app/pages/Master/SeriesProductMaster/Mattle/AddMattle"));

const Canvas = lazy(() => import("app/pages/Master/SeriesProductMaster/Canvas"));
const AddCanvas = lazy(() => import("app/pages/Master/SeriesProductMaster/Canvas/AddCanvas"));

const Novel = lazy(() => import("app/pages/Master/SeriesProductMaster/Novel"));
const AddNovel = lazy(() => import("app/pages/Master/SeriesProductMaster/Novel/AddNovel"));

const Marvel = lazy(() => import("app/pages/Master/SeriesProductMaster/Marvel"));
const AddMarvel = lazy(() => import("app/pages/Master/SeriesProductMaster/Marvel/AddMarvel"));

const RegantoClassic = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoClassic"));
const AddRegantoClassic = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoClassic/AddRegantoClassic"));

const RegantoDeziner = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoDeziner"));
const AddRegantoDeziner = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoDeziner/AddRegantoDeziner"));

const RegantoPremier = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoPremier"));
const AddRegantoPremier = lazy(() => import("app/pages/Master/SeriesProductMaster/RegantoPremier/AddRegantoPremier"));

const Acco = lazy(() => import("app/pages/Master/SeriesProductMaster/Acco"));
const AddAcco = lazy(() => import("app/pages/Master/SeriesProductMaster/Acco/AddAcco"));

const FurrowLite = lazy(() => import("app/pages/Master/SeriesProductMaster/FurrowLite"));
const AddFurrowLite = lazy(() => import("app/pages/Master/SeriesProductMaster/FurrowLite/AddFurrowLite"));

const FurrowReganto = lazy(() => import("app/pages/Master/SeriesProductMaster/FurrowReganto"));
const AddFurrowReganto = lazy(() => import("app/pages/Master/SeriesProductMaster/FurrowReganto/AddFurrowReganto"));


export const seriesProductRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "barcode_series_product", "view"],
      },
    ],
    routes: [
      {
        path: BARCODE,
        element: LoadablePage(Barcode),
      },
      {
        path: BARCODE_ADD,
        element: LoadablePage(AddBarcode),
      },
      {
        path: BARCODE_EDIT,
        element: LoadablePage(AddBarcode),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: [
          "/dashboard",
          "chroma_collection_series_product",
          "view",
        ],
      },
    ],
    routes: [
      {
        path: CHROMA_COLLECTION,
        element: (
          LoadablePage(ChromaCollection)
        ),
      },
      {
        path: CHROMA_COLLECTION_ADD,
        element: (
          LoadablePage(AddChromaCollection)
        ),
      },
      {
        path: CHROMA_COLLECTION_EDIT,
        element: (
          LoadablePage(AddChromaCollection)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "chroma_composite_series_product", "view"],
      },
    ],
    routes: [
      {
        path: CHROMA_COMPOSITE,
        element: (
          LoadablePage(ChromaComposite)
        ),
      },
      {
        path: CHROMA_COMPOSITE_ADD,
        element: (
          LoadablePage(AddChromaComposite)
        ),
      },
      {
        path: CHROMA_COMPOSITE_EDIT,
        element: (
          LoadablePage(AddChromaComposite)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "chroma_ribbed_series_product", "view"],
      },
    ],
    routes: [
      {
        path: CHROMA_RIBBED,
        element: LoadablePage(ChromaRibbed),
      },
      {
        path: CHROMA_RIBBED_ADD,
        element: (
          LoadablePage(AddChromaRibbed)
        ),
      },
      {
        path: CHROMA_RIBBED_EDIT,
        element: (
          LoadablePage(AddChromaRibbed)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "bunito_series_product", "view"],
      },
    ],
    routes: [
      {
        path: BUNITO,
        element: LoadablePage(Bunito),
      },
      {
        path: BUNITO_ADD,
        element: LoadablePage(AddBunito),
      },
      {
        path: BUNITO_EDIT,
        element: LoadablePage(AddBunito),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "mattle_series_product", "view"],
      },
    ],
    routes: [
      {
        path: MATTLE,
        element: LoadablePage(Mattle),
      },
      {
        path: MATTLE_ADD,
        element: LoadablePage(AddMattle),
      },
      {
        path: MATTLE_EDIT,
        element: LoadablePage(AddMattle),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "canvas_series_product", "view"],
      },
    ],
    routes: [
      {
        path: CANVAS,
        element: LoadablePage(Canvas),
      },
      {
        path: CANVAS_ADD,
        element: LoadablePage(AddCanvas),
      },
      {
        path: CANVAS_EDIT,
        element: LoadablePage(AddCanvas),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "novel_series_product", "view"],
      },
    ],
    routes: [
      {
        path: NOVEL,
        element: LoadablePage(Novel),
      },
      {
        path: NOVEL_ADD,
        element: LoadablePage(AddNovel),
      },
      {
        path: NOVEL_EDIT,
        element: LoadablePage(AddNovel),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "marvel_series_product", "view"],
      },
    ],
    routes: [
      {
        path: MARVEL,
        element: LoadablePage(Marvel),
      },
      {
        path: MARVEL_ADD,
        element: LoadablePage(AddMarvel),
      },
      {
        path: MARVEL_EDIT,
        element: LoadablePage(AddMarvel),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "reganto_deziner_series_product", "view"],
      },
    ],
    routes: [
      {
        path: REGANTO_DEZINER,
        element: (
          LoadablePage(RegantoDeziner)
        ),
      },
      {
        path: REGANTO_DEZINER_ADD,
        element: (
          LoadablePage(AddRegantoDeziner)
        ),
      },
      {
        path: REGANTO_DEZINER_EDIT,
        element: (
          LoadablePage(AddRegantoDeziner)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "reganto_classic_series_product", "view"],
      },
    ],
    routes: [
      {
        path: REGANTO_CLASSIC,
        element: (
          LoadablePage(RegantoClassic)
        ),
      },
      {
        path: REGANTO_CLASSIC_ADD,
        element: (
          LoadablePage(AddRegantoClassic)
        ),
      },
      {
        path: REGANTO_CLASSIC_EDIT,
        element: (
          LoadablePage(AddRegantoClassic)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "reganto_premier_series_product", "view"],
      },
    ],
    routes: [
      {
        path: REGANTO_PREMIER,
        element: (
          LoadablePage(RegantoPremier)
        ),
      },
      {
        path: REGANTO_PREMIER_ADD,
        element: (
          LoadablePage(AddRegantoPremier)
        ),
      },
      {
        path: REGANTO_PREMIER_EDIT,
        element: (
          LoadablePage(AddRegantoPremier)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "acco_series_product", "view"],
      },
    ],
    routes: [
      {
        path: ACCO,
        element: (
          LoadablePage(Acco)
        ),
      },
      {
        path: ACCO_ADD,
        element: (
          LoadablePage(AddAcco)
        ),
      },
      {
        path: ACCO_EDIT,
        element: (
          LoadablePage(AddAcco)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "furrow_series_product", "view"],
      },
    ],
    routes: [
      {
        path: FURROW,
        element: LoadablePage(Furrow),
      },
      {
        path: FURROW_ADD,
        element: LoadablePage(AddFurrow),
      },
      {
        path: FURROW_EDIT,
        element: LoadablePage(AddFurrow),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: [
          "/dashboard",
          "furrow_lite_series_product",
          "view",
        ],
      },
    ],
    routes: [
      {
        path: FURROW_LITE,
        element: (
          LoadablePage(FurrowLite)
        ),
      },
      {
        path: FURROW_LITE_ADD,
        element: (
          LoadablePage(AddFurrowLite)
        ),
      },
      {
        path: FURROW_LITE_EDIT,
        element: (
          LoadablePage(AddFurrowLite)
        ),
      },
    ],
  },
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: [
          "/dashboard",
          "furrow_reganto_series_product",
          "view",
        ],
      },
    ],
    routes: [
      {
        path: FURROW_REGANTO,
        element: (
          LoadablePage(FurrowReganto)
        ),
      },
      {
        path: FURROW_REGANTO_ADD,
        element: (
          LoadablePage(AddFurrowReganto)
        ),
      },
      {
        path: FURROW_REGANTO_EDIT,
        element: (
          LoadablePage(AddFurrowReganto)
        ),
      },
    ],
  },
];
